/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import { EOperationType } from '@/common/enum/shop';
import { IShopOperationLogItem } from '@/common/interface/shop';
import { inject, injectable } from 'inversify';
import HttpClient from './http.service';

@injectable()
export class ShopOperationLogService {
  @inject(HttpClient)
  protected http!: HttpClient;

  async list(reqParams: {
    page_size: number;
    page: number;
    operate_type: string;
    shop_id?: number | string; // 批量商品将不传shop_id
    ext_idx?: number;
  }) {
    try {
      const url = '/shop/trace_log';
      const params = Object.assign({}, reqParams);

      if (reqParams.operate_type === EOperationType.SHOP_LICENSE) {
        params.operate_type = 'shopLiscen';
      }
      if (reqParams.operate_type === EOperationType.BOSS_ID_IMAGES) {
        params.operate_type = 'shopIdImage';
      }
      if (reqParams.operate_type === EOperationType.LEADING_SPU) {
        params.operate_type = 'batchTemplate';
      }
      if (reqParams.operate_type === EOperationType.SHOP_AUDIT_VIDEO) {
        params.operate_type = 'shopAuditVideo';
      }
      if (reqParams.operate_type === EOperationType.ONSITESERVICEFLAG) {
        params.operate_type = 'onsiteServiceFlag';
      }
      if (reqParams.operate_type === EOperationType.OTHER_QUALIFICATIONS) {
        params.operate_type = 'otherQualifications';
      }
      if (reqParams.operate_type === EOperationType.MAINTENANCE_OPERATIONAL_VEHICLES) {
        params.operate_type = 'maintenanceOperationalVehicles';
      }
      if (reqParams.operate_type === EOperationType.ROAD_TRANSPORT_BUSINESS_LICENSE) {
        params.operate_type = 'roadTransportBusinessLicense';
      }
      // if (reqParams.operate_type === EOperationType.SPUHISTORY) {
      //   params.operate_type = 'spuHistory';
      // }
      // if (reqParams.operate_type === EOperationType.BATCHTEMPLATE) {
      //   params.operate_type = 'batchTemplate';
      // }

      const res = (await this.http.get(url, { params })) as {
        list: any[];
        total: number;
        pageSize: number;
        page: number;
        prev_data: any; // 与res 一致；
      };
      if (res) {
        const { total, pageSize, page, list, prev_data } = res;
        const data = {
          total,
          pageSize,
          page,
          list: [] as IShopOperationLogItem[],
        };
        const getContent = (param: {
          type: EOperationType;
          detail: any[];
          prevDetail?: any[];
          operate_desc?: string;
          result?: any;
          desc?: string;
        }) => {
          const { type, detail, prevDetail, operate_desc, result, desc } = param;

          if (
            type !== EOperationType.BOSS_ID_IMAGES &&
            type !== EOperationType.SHOP_IMAGES &&
            type !== EOperationType.SHOP_LICENSE &&
            type !== EOperationType.SHOP_AUDIT_VIDEO &&
            type !== EOperationType.SPUHISTORY &&
            type !== EOperationType.BATCHTEMPLATE &&
            type !== EOperationType.OTHER_QUALIFICATIONS &&
            type !== EOperationType.MAINTENANCE_OPERATIONAL_VEHICLES &&
            type !== EOperationType.ROAD_TRANSPORT_BUSINESS_LICENSE
          ) {
            if (type === EOperationType.LEADING_SPU) {
              return operate_desc;
            }
            if (type === EOperationType.STAFF) {
              return `${operate_desc}：${detail}`;
            }
            if (type === EOperationType.OPERATION_RECORD) {
              let text = `${operate_desc}：${detail}`;
              if (desc) {
                text = `${text} (${desc})`;
              }
              return text;
            }
            if (type === EOperationType.ONSITESERVICEFLAG) {
              return `${operate_desc}：为${detail} ${JSON.parse(result).data ? JSON.parse(result).data : `操作失败 ${ JSON.parse(result).error}`}`;
            }
            return detail;
          }
          return {
            previous: prevDetail,
            current: detail,
          };
        };

        for (let index = 0; index < list.length; index++) {
          const prevDataDetail =
            prev_data && prev_data.detail ? prev_data.detail : [];
          const prevData =
            index === list.length - 1 ? prevDataDetail : list[index + 1].detail;
          const item = list[index];
          const operItem = {
            id: item.id,
            operateTime: item.operate_time,
            operatorId: item.operate_id,
            operatorName: item.operate_name,
            operateDesc: item.operate_desc,
            content: getContent({
              type: reqParams.operate_type as EOperationType,
              detail: item.detail,
              prevDetail: prevData,
              operate_desc: item.operate_desc,
              result: item.result,
              desc: item.desc,
            }),
          };
          data.list.push(operItem);
        }
        return data;
      }
      return null;
    } catch (error) {
      throw error;
    }
  }
async traceLogPrev(params: any) {
  try {
    const url = '/shop/trace_log_prev';
    return (await this.http.get(url, { params })) as any;
  } catch (error) {
    throw error;
  }
}
}
